import React, { useEffect } from "react";
import Banner from "../Components/Contact/Banner";
import Cards from "../Components/Contact/Cards";
import Form from "../Components/Contact/Form";
import { useHome } from "../Context/HomeContext";
import { usePagesBanners } from "../Context/PagesBannersContext";

function Contact() {
  const { getContact, isContact } = useHome("");
  const { isBanner } = usePagesBanners();

  useEffect(() => {
    getContact();
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <div className="flex flex-col mx-[2rem] lg:mx-[7rem] md:mx-[4rem] items-center gap-7">
      <Banner isBanner={isBanner?.data[6]} />
      <Cards isContact={isContact?.data} />
      <Form />
    </div>
  );
}

export default Contact;
